import React, { Component } from 'react'
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';
import { DatePicker, List } from 'antd-mobile/lib';
import moment from 'moment';


const nowTimeStamp = Date.now();
const dataval = moment(nowTimeStamp)
export default class ChangTime extends Component {
    state = {
        date: dataval,
        agreeIndex: 0,
        dateValueTime: dataval.format('YYYY-MM-DD')
      }
    
    goBack = () => {
		window._czc.push(["_trackEvent", "华夏财富H5", "设置证件有效期", "回退"]);
		hashHistory.goBack();
	}
    getShowDate=(value)=>{
        let dateValue = value.format('YYYY-MM-DD');
        this.setState({
            dateValueTime: dateValue
        })
        return dateValue;
    }
    goBacks = () => {
        if(this.state.agreeIndex=="1"){
        this.setState({
            agreeIndex: 0
            })
        }else{
        this.setState({
            agreeIndex: 1
            })
        }
    }
    zjyxq = () => {
        let onFun = this.props.location.state.onFun
        let valu = this.props.location.state.valu
        let objzzh ={
            certValidTerm: this.state.agreeIndex=="1"?"长期有效":this.state.dateValueTime,
            certValidEver: this.state.agreeIndex=="1"?"1":"0",
        }
        let objkzr ={
            actualControllerValidTerm: this.state.agreeIndex=="1"?"长期有效":this.state.dateValueTime,
            actualControllerValidEver: this.state.agreeIndex=="1"?"1":"0",
            str:"控制人证件有效期"
        }
        let objkzrs ={
            actualControllerBirthday: this.state.dateValueTime,
            str:"控制人出生日期"
        }
        let objsyr ={
            actualBeneficiaryValidTerm: this.state.agreeIndex=="1"?"长期有效":this.state.dateValueTime,
            actualBeneficiaryValidEver: this.state.agreeIndex=="1"?"1":"0",
            str:"受益人证件有效期"
        }
        let objsyrs ={
            actualBeneficiaryBirthday: this.state.dateValueTime,
            str:"受益人出生日期"
        }
        if(valu=="控制人证件有效期"){
            onFun(objkzr)
        }else if(valu=="受益人证件有效期"){
            onFun(objsyr)
        }else if(valu=="控制人出生日期"){
            onFun(objkzrs)
        }else if(valu=="受益人出生日期"){
            onFun(objsyrs)
        }else if(valu=="主账户证件有效期"){
            onFun(objzzh)
        }
        hashHistory.goBack();
    }
    onChanges = (datas) => {
        console.log(datas)
        let dateValue = datas.format('YYYY-MM-DD');
        this.setState({
            date: datas,
            dateValueTime: dateValue
        })
    }
  render() {
      console.log(this.state.date)
    const img_arr = [require('../../img/square@3x.png'),require('../../img/squareHooks@3x.png')]
    return (
      <div>
        <NavigatorMain>
            <div className="boxHeader">
                <div>
                    <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
                </div>
                <div>
                    <span>设置{this.props.location.state.valu}</span>
                </div>
                <div>
                    
                </div>
            </div>
        </NavigatorMain>
        <div className="boxContent">
           {
               this.props.location.state.valu=="控制人证件有效期" || this.props.location.state.valu=="受益人证件有效期" || this.props.location.state.valu=="主账户证件有效期"?
                <div style={{display:"flex",paddingLeft:"0.2rem",alignItems:"center",background:"#fff",borderBottom:"1px solid gray",paddingRight:"0.2rem"}}>
                    <div style={{flex:1}}>是否长期有效</div>
                    <div> <img style={{width:"0.6rem",height:"0.6rem"}} onClick={this.goBacks} src={img_arr[this.state.agreeIndex]} /></div>    
                </div>
                :null
           } 
            <DatePicker
            mode="date"
            title="选择时间"
            // extra="Optional"
            minDate={moment(new Date(1900, 1, 1, 23, 59, 59))}
            maxDate={moment(new Date(2222, 1, 1, 23, 59, 59))}
            value={this.state.date}
            format={(value: Date)=>{return value.format('YYYY-MM-DD');}}
            onChange={(data)=>{this.onChanges(data)}}
            >
                <List.Item arrow="horizontal">请选择日期</List.Item>
            </DatePicker>
            <div style={{display:"flex",justifyContent:"center",paddingTop:"0.2rem"}}>
                <div onClick={this.zjyxq} style={{width:"3rem",height:"0.6rem",background:"red",borderRadius:"10px",border:"0",color:"#000",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"20px"}}>提交</div>
            </div>
        </div> 
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/recommend/ChangTime.js